import { Box, Grid } from "@mui/material";
import { FC } from "react";
import { AdminSideNav } from "../../common/admin-side-nav/admin-side-nav";
import { AdminTopNav } from "../../common/admin-top-nav/admin-top-nav";

export interface IAdminLayoutProps {
  children: React.ReactNode;
}

export const AdminLayout: FC<IAdminLayoutProps> = ({ children }) => {
  return (
    <Grid
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        backgroundColor: "#f4f4f4",
      }}
    >
      <AdminSideNav />
      <Grid flex={1} sx={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <AdminTopNav />
        <Box sx={{ flex: 1, p: "1.14rem", overflow: "hidden" }}>
          <Box
            sx={{
              backgroundColor: "#ffffff",
              borderRadius: "1.07rem",
              height: "100%",
              overflow: "auto",
              p: "2rem",
            }}
          >
            {children}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
